import { render, staticRenderFns } from "./DSCalendarIcon.vue?vue&type=template&id=e62681c0&scoped=true&"
import script from "./DSCalendarIcon.vue?vue&type=script&lang=js&"
export * from "./DSCalendarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62681c0",
  null
  
)

export default component.exports